"use strict";

import angular from "angular";

import serviceEventUpdateFormDirective from "./service-event-update-form";

const MODULE_NAME = "daupler.components";

const app = angular.module(MODULE_NAME, []);

app.directive("serviceEventUpdateForm", serviceEventUpdateFormDirective);

export default MODULE_NAME;
